import { PawPrintIcon } from '@phosphor-icons/react';
import React, { useCallback, useState } from 'react';

import { chevronBack, close as closeIcon } from 'ionicons/icons';

import { useAlert } from '../../../hooks/UI/useAlert';
import Alert from '../../UI/Alert';
import Button from '../../UI/Button';
import FormHeader from '../../UI/FormHeader';
import Navigation from '../../UI/Navigation';
import Alimentacion from '../Alimentacion';
import Pesaje from '../Pesaje';
import './SectionViewer.scss';
import { SectionViewerProps } from './types';

const SectionViewer: React.FC<SectionViewerProps> = ({ pet, closeModal }) => {
  const [section, setSection] = useState<'pesaje' | 'alimentacion' | null>(null);
  const [view, setView] = useState<'agregar' | 'historial' | null>(null);
  const { alertState, showAlert, hideAlert } = useAlert();

  const handleBack = useCallback(() => {
    if ((section === 'pesaje' || section === 'alimentacion') && view !== null) {
      setView(null);
    } else {
      setSection(null);
    }
  }, [section, view, setView, setSection]);

  const getTitle = useCallback(() => {
    const petName = pet?.nombre ?? '';

    if (section === 'alimentacion') {
      if (view === 'historial') return `Historial de alimentación de ${petName}`;
    }

    if (section === 'pesaje') {
      if (view === 'historial') return `Historial de pesaje de ${petName}`;
    }

    return undefined;
  }, [section, view, pet]);

  return (
    <div className="section-viewer">
      <Navigation
        startIcon={section === null ? closeIcon : chevronBack}
        onBack={section === null ? closeModal : handleBack}
        title={getTitle()}
      />

      {section === null && (
        <>
          <FormHeader
            icon={<PawPrintIcon />}
            title="Alimentación y Pesaje"
            subtitle={`Registrá la alimentación y el peso de ${pet?.nombre}`}
          />

          <div className="ion-padding">
            <Button marginBottom={false} onClick={() => setSection('alimentacion')}>
              Alimentación
            </Button>

            <Button noMarginTop onClick={() => setSection('pesaje')}>
              Pesaje
            </Button>
          </div>
        </>
      )}

      {section === 'alimentacion' && (
        <Alimentacion
          view={view}
          setView={setView}
          showAlert={showAlert}
          hideAlert={hideAlert}
          nombre={pet.nombre}
        />
      )}

      {section === 'pesaje' && (
        <Pesaje view={view} setView={setView} showAlert={showAlert} nombre={pet.nombre} />
      )}

      <Alert
        isOpen={alertState.isOpen}
        header={alertState.header}
        message={alertState.message}
        buttons={alertState.buttons}
        onDidDismiss={hideAlert}
      />
    </div>
  );
};

export default React.memo(SectionViewer);
